import { render, staticRenderFns } from "./NewHookUpdated.vue?vue&type=template&id=2df91c13&"
import script from "./NewHookUpdated.vue?vue&type=script&lang=js&"
export * from "./NewHookUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports